import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MenuLayout from "./MenuLayout";
import "../styles/TicketDetailPage.css";
import { addTicketMessage, getTicket } from "../api/ticket";

const TicketDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ticket, setTicket] = useState(null);
  const [reply, setReply] = useState("");
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  const loadTicket = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      setTicket(await getTicket(id));
    } catch (err) {
      setError(err?.message || "خطا در دریافت تیکت");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    loadTicket();
  }, [loadTicket]);

  const handleReply = async () => {
    const message = reply.trim();
    if (!message || sending || ticket?.status === "closed") return;
    setSending(true);
    setError("");
    try {
      await addTicketMessage(id, message);
      setReply("");
      await loadTicket();
    } catch (err) {
      setError(err?.message || "ارسال پیام انجام نشد");
    } finally {
      setSending(false);
    }
  };

  return (
    <MenuLayout>
      <div className="ticket-detail-page">
        <header className="ticket-detail-header">
          <h1 className="ticket-detail-title">{ticket?.subject || "مشاهده تیکت"}</h1>
          <p className="ticket-detail-subtitle">
            {ticket ? `شماره تیکت: ${ticket.ticket_number || ticket.id}` : "مکاتبات این تیکت را مشاهده کنید."}
          </p>
        </header>

        {error && <div className="ticket-detail-error">{error}</div>}
        <div className="ticket-detail-list">
          {loading ? (
            <div className="ticket-detail-empty">در حال دریافت تیکت...</div>
          ) : !ticket?.messages?.length ? (
            <div className="ticket-detail-empty">هنوز پیامی در این تیکت ثبت نشده است.</div>
          ) : (
            ticket.messages.map((msg) => (
              <div
                className={`ticket-detail-card ${msg.is_admin ? "ticket-detail-card-highlight" : ""}`}
                key={msg.id}
              >
                <div className="ticket-detail-avatar">
                  <img src="/images/profile/avatar-big.svg" alt="" />
                </div>
                <div className="ticket-detail-body">
                  <div className="ticket-detail-meta">
                    <div className="ticket-detail-name">{msg.is_admin ? "پشتیبانی تاچ پراپ" : "شما"}</div>
                    <div className={`ticket-detail-role ${msg.is_admin ? "role-admin" : "role-user"}`}>
                      {msg.is_admin ? "پاسخ پشتیبانی" : "پیام کاربر"}
                    </div>
                  </div>
                  <p className="ticket-detail-text">{msg.message}</p>
                  {msg.file_url && (
                    <a className="ticket-detail-attachment" href={msg.file_url} target="_blank" rel="noreferrer">
                      مشاهده فایل پیوست
                    </a>
                  )}
                </div>
                {msg.is_admin && <div className="ticket-detail-badge">پاسخ</div>}
              </div>
            ))
          )}
        </div>

        <div className="ticket-detail-reply">
          <label className="ticket-detail-reply-label">متن ارسال پیام:</label>
          <textarea
            className="ticket-detail-reply-textarea"
            placeholder={ticket?.status === "closed" ? "این تیکت بسته شده است." : "پیام خود را بنویسید"}
            value={reply}
            onChange={(event) => setReply(event.target.value)}
            disabled={ticket?.status === "closed" || sending}
          />
          <button
            className="ticket-detail-submit"
            onClick={handleReply}
            disabled={!reply.trim() || sending || ticket?.status === "closed"}
          >
            {sending ? "در حال ارسال..." : "تایید و ارسال"}
          </button>
          <button className="ticket-detail-back" onClick={() => navigate("/tickets")}>
            بازگشت
          </button>
        </div>
      </div>
    </MenuLayout>
  );
};

export default TicketDetailPage;
